import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'trackfleet_cookie_consent';

export default function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-4 pointer-events-none">
      <div className="max-w-2xl mx-auto pointer-events-auto">
        <div className="bg-white border border-gray-200 rounded-xl shadow-lg p-4 flex items-start gap-3">
          <Shield className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-gray-700">
              {t('cookie_consent.body')}{' '}
              <Link to="/privacy" className="text-green-600 font-medium hover:underline">
                {t('cookie_consent.privacy_link')}
              </Link>
            </p>
          </div>
          <button
            onClick={accept}
            className="flex-shrink-0 px-3 py-1.5 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors"
          >
            {t('cookie_consent.accept')}
          </button>
          <button
            onClick={accept}
            className="flex-shrink-0 p-1 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
